export const SERVICE_PARAM = 'olaS';
export const AVAILABLE_TIME_PARAM = 'olaT';
export const RESOURCE_PARAM = 'olaR';
export const BLOG_URL_PATH = 'f';
export const FRIENDLY_SERVICE_URL_PATH = 'ola/services';
